import { render, staticRenderFns } from "./DidntReturnStaffTableSubHeader.vue?vue&type=template&id=7e8d97aa&scoped=true"
import script from "./DidntReturnStaffTableSubHeader.vue?vue&type=script&lang=js"
export * from "./DidntReturnStaffTableSubHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8d97aa",
  null
  
)

export default component.exports